<template>
    <v-dialog
        v-model="display"
        width="500"
        >
        <v-card>
            <v-card-title class="text-h5 grey lighten-2">
                {{content.title}}
            </v-card-title>

            <v-card-text>
                {{content.message}}
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="primary"
                text
                @click="callback()"
            >
                {{content.button || 'Close'}}
            </v-btn>
            <v-btn
                color="secondary"
                text
                @click="callback()"
                v-if="content.alt && content.alt.length"
            >
                {{content.alt}}
            </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'dialog-modal',
  props: ['content', 'cb', 'alt_cb', 'display'],
  data () {
      return {
      }
  },
  mounted () {
  },
  methods: {
      callback: function () {
          if (this.cb) {
              this.cb()
          }
          this.$store.dispatch('close_dialog')
      },
      altCallback: function () {
          if (this.altCb) {
              this.altCb()
          }
          this.$store.dispatch('close_dialog')
      }
  }
}
</script>

<style>

</style>